import { ReactNode, useEffect, useState } from 'react';
import { Button } from '@/components/ui/button.js';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu.js';
import { pluralize } from '@/lib/string-utils.js';
import { ChevronDown } from 'lucide-react';

interface TableBulkActionsMenuProps {
  children: ReactNode;
  disabled?: boolean;
  selectedRowsCount: number;
  isSelectAllPagesActive?: boolean;
  totalRowCount?: number;
  triggerTestId?: string;
}

export const TableBulkActionsMenu = ({
  children,
  disabled,
  selectedRowsCount,
  isSelectAllPagesActive,
  totalRowCount,
  triggerTestId,
}: TableBulkActionsMenuProps) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selectedRowsCount === 0 && !isSelectAllPagesActive) {
      setOpen(false);
    }
  }, [selectedRowsCount, isSelectAllPagesActive]);

  const displayText = isSelectAllPagesActive
    ? `Bulk actions (${totalRowCount} rows)`
    : `Bulk actions ${selectedRowsCount ? `(${selectedRowsCount} ${pluralize(selectedRowsCount, 'row', 'rows')})` : ''}`;

  return (
    <DropdownMenu modal={false} open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          className="ml-auto hidden h-8 lg:flex"
          disabled={disabled}
          variant="secondary"
          data-testid={triggerTestId}
        >
          {displayText}
          <ChevronDown className="mr-2 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="max-w-[250px]">
        {children}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
